export const { VITE_SST_API_URL: SST_API_URL, VITE_SWIFTID_KYC_DOMAIN: SWIFTID_KYC_DOMAIN } = import.meta.env
export const { VITE_ENV: ENV } = import.meta.env
export const { VITE_DEVICE_AUTH_INACTIVITY_MINUTES: DEVICE_AUTH_INACTIVITY_MINUTES = 5 } = import.meta.env
